import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';
import { FaHome, FaFileAlt, FaClipboardCheck, FaCalendar, FaFileSignature, FaSignOutAlt, FaPauseCircle, FaExclamation, FaClock, FaUserFriends } from 'react-icons/fa';
import imagen2 from '../img/get_view2.png';

const Sidebar = () => {
  const navigate = useNavigate();
  const handleInicioClick = () => navigate('/menusolicitante');
  const handleNuevaSolicitudClick = () => navigate('/SolicitarServicioGET');
  const handleEsperaDocumentacionClick = () => navigate('/EsperaDocumentos');
  const handleCreadasGETClick = () => navigate('/SolicitudesCreadasGET');
  const handlePorAprobarClick = () => navigate('/RevisarActividadSolicitante');
  const handleCompletadasClick = () => navigate('/SolicitudesCompletadasSenior');
  const handleEnPausaClick = () => navigate('/EnPausaSolicitante');
  const handleCanceladasClick = () => navigate('/SolicitudesCanceladas');
  
  const handleExitClick = () => {
    navigate('/'); // Redirige al usuario a la página de inicio de sesión o la ruta principal
    localStorage.clear(); // Elimina todos los elementos de localStorage
    window.location.reload(); // Refresca la página
  };

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <img src={imagen2} alt="GET View Logo" className="sidebar-logo" />
      </div>
      <div className="sidebar-section">
        <p>Aplicaciones</p>
        <div className="profile-link" onClick={handleInicioClick}>
          <FaHome /> Inicio
        </div>
        <div className="profile-link" onClick={handleNuevaSolicitudClick}>
          <FaFileSignature /> Nueva solicitud
        </div>
        <div className="profile-link multiline-text" onClick={handleEsperaDocumentacionClick}>
          <FaCalendar /> Solicitudes por documentar
        </div>
        <div className="profile-link multiline-text" onClick={handleCreadasGETClick}>
          <FaFileAlt /> Solicitudes creadas
        </div>
        <div className="profile-link" onClick={handleEnPausaClick}>
          <FaPauseCircle /> Solicitudes en pausa
        </div>
        <div className="profile-link" onClick={handlePorAprobarClick}>
          <FaClock /> Solicitudes por aprobar
        </div>
        <div className="profile-link" onClick={handleCanceladasClick}>
          <FaExclamation/> Solicitudes anuladas
        </div>
        <div className="profile-link" onClick={handleCompletadasClick}>
          <FaClipboardCheck /> Solicitudes finalizadas
        </div>
      </div>
      <div className="sidebar-section bottom-items">
        <p>Otros</p>
        <div className="profile-link" onClick={handleExitClick}>
          <FaSignOutAlt /> Cerrar Sesión
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
